<template>
  <v-col cols="12">
    <v-row
      :justify="'space-between'"
      class="mt-3 main-header mb-2 mx-1 font-weight-bold"
    >
      <v-col cols="5">Store Clubs</v-col>
    </v-row>
    <v-row class="mt-0 pb-1">
      <v-col cols="12" class="header-text"> Available Rewards </v-col>
    </v-row>
    <v-row class="mt-0 pt-0">
      <v-col cols="12" class="click-to-see-rewards pt-0">
        <span v-if="availableRewards().length"
          >Click to see rewards you can redeem right now</span
        >
        <span v-else>No rewards available</span>
      </v-col>
    </v-row>
    <RewardsTabs type="clubs" :clubs="availableRewards()" :redeemable="true" />
    <v-row class="pb-1">
      <v-col cols="12" class="header-text"> In Progress Clubs </v-col>
    </v-row>
    <v-row class="mt-0 pt-0">
      <v-col cols="12" class="click-to-see-rewards pt-0">
        <span v-if="inProgressClubs().length"
          >Click to see rewards you can redeem after completing the club</span
        >
        <span v-else>No in progress clubs</span>
      </v-col>
    </v-row>
    <RewardsTabs type="clubs" :clubs="inProgressClubs()" />
    <v-row class="pb-1">
      <v-col cols="12" class="header-text"> Other Clubs </v-col>
    </v-row>
    <v-row class="mt-0 pt-0">
      <v-col cols="12" class="click-to-see-rewards pt-0">
        <span v-if="otherClubs().length"
          >Click to see rewards you can redeem if you buy items in the
          club</span
        >
        <span v-else>No other clubs available</span>
      </v-col>
    </v-row>
    <RewardsTabs type="clubs" :clubs="otherClubs()" />
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";
import RewardsTabs from "../Tabs.vue";
export default {
  name: "XsClubs",
  components: {
    RewardsTabs,
  },
  computed: {
    ...mapGetters("store", {
      clubs: "clubs",
    }),
  },
  methods: {
    availableRewards() {
      return this.clubs.filter((c) => c.free_products_qty > 0);
    },
    inProgressClubs() {
      return this.clubs.filter(
        (c) => c.free_products_qty == 0 && c.stars_in_this_cycle > 0,
      );
    },
    otherClubs() {
      return this.clubs.filter(
        (c) => c.free_products_qty == 0 && c.stars_in_this_cycle == 0,
      );
    },
  },
};
</script>
